"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertCreditCardToPaymentMethod = convertCreditCardToPaymentMethod;

function convertCreditCardToPaymentMethod(creditCard) {
  var cardName = creditCard.CardName,
      expDate = creditCard.ExpDate,
      cardHolder = creditCard.CardHolder,
      id = creditCard.ID,
      account = creditCard.Account;
  var firstName = cardHolder.FirstName,
      lastName = cardHolder.LastName;
  var expMonth = expDate.substring(0, 2);
  var expYear = expDate.substring(2, 4);
  return {
    card_type: cardName.toUpperCase(),
    expiration: "".concat(expMonth, "/").concat(expYear),
    expiration_month: expMonth,
    expiration_year: expYear,
    full_name: capitalizeName("".concat(firstName, " ").concat(lastName)),
    payment_method_token: id,
    last_four: account.slice(-4)
  };
}

function capitalizeName(fullName) {
  return fullName.toLowerCase().split(' ').map(function (name) {
    return name ? name[0].toUpperCase() + name.slice(1) : '';
  }).join(' ');
}